<script>
export default {
  name: "UpsellElement",
  dropsAsElementType: "DynamicComponentElement",
  elementPanelSettings: {
    displayName: "Upsell",
    displayIcon: "material-symbols:workspace-premium",
    elementType: "element",
    elementGroup: "general",
  },
  dropRootOptions: {
    "light-mode": {
      default: {
        default: {
          "subscriber-gate": { r: "yes" },
        },
      },
    },
  },
};
</script>
